"use client";
import styled from "styled-components";

export const ChartWrapper = styled.div`
  font-size: 12px;
  line-height: 1em;
  width: 100%;
  height: 400px;
`;
